module.exports = {
	"header": "Staff access settings",
	"activeUsersH2": "Active staff users",
	"activeUsersOwner": "Owner",
	"activeUsersP": "The following users have access to this seller account:",
	"activeUsersThEmails": "E-mail(s)",
	"inviteUserBtn": "Invite staff user",
	"newInviteModalEmailLabel": "Send an invite to manage this seller account to the following e-mail address:",
	"newInviteModalEmailPlaceholder": "contact@example.com",
	"newInviteModalTitle": "Invite new user",
	"noPendingInvites": "There are no pending staff invites.",
	"pendingInvitesH2": "Pending staff invites",
	"pendingInvitesP": "The following e-mails have pending staff invites for this seller account:",
	"pendingInvitesThInviteDate": "Invite sent on",
	"removeAccessModalRemoveAccessBtn": "Revoke access",
	"removeAccessModalEmailLabel": "Are you sure you want to remove staff access of this user?",
	"removeAccessModalTitle": "Remove user staff access to this seller account"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/oa-staffAccess.json5
// module id = 1947
// module chunks = 6